module.exports = __webpack_public_path__ + "img/300.15920445.jpg";